export const SERVER_ERROR = "SERVER_ERROR";
export const CLEAR_SERVER_ERROR = "CLEAR_SERVER_ERROR";



// WEBPACK FOOTER //
// ./src/server/action-types.js